import React from "react";
import PropTypes from "prop-types";
import { FormInput } from "MODULES/shared/components/Forms";
import { Field } from "redux-form";
import { Col } from "react-bootstrap";
import CurrencyField from "MODULES/shared/components/Forms/CurrencyField/CurrencyField";
import { properCase } from "LIB/formatters/text";
import { INVOICE_PAID_DATE } from "MODULES/SalesOrders/constants";
import FormRow from "../../shared/components/Forms/FormRow";
import {
  AMOUNT_PAID,
  INVOICE_NUMBER,
  PURCHASE_ORDER
} from "../../PurchaseOrders/constants";

export default function InvoiceSection({ disabled, hidden, orderType }) {
  if (hidden) {
    return null;
  }

  return (
    <React.Fragment>
      <hr className="hr-xs hr-dashed" />
      <h4>Billing</h4>
      <FormRow>
        <Col md={3}>
          <Field
            name={INVOICE_NUMBER}
            component={FormInput}
            label="Invoice #"
            disabled={disabled}
          />
        </Col>
        {orderType === PURCHASE_ORDER && (
          <Col md={3}>
            <Field
              type="date"
              name="invoice_due_date"
              component={FormInput}
              label="Invoice Due Date"
              disabled={disabled}
            />
          </Col>
        )}
        <Col md={3}>
          <Field
            type="date"
            name={INVOICE_PAID_DATE}
            component={FormInput}
            label={properCase(INVOICE_PAID_DATE)}
            disabled={disabled}
          />
        </Col>
        <Col md={3}>
          <Field
            name={AMOUNT_PAID}
            component={CurrencyField}
            label={properCase(AMOUNT_PAID)}
            disabled={disabled}
          />
        </Col>
      </FormRow>
    </React.Fragment>
  );
}

InvoiceSection.propTypes = {
  disabled: PropTypes.bool,
  hidden: PropTypes.bool,
  orderType: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/modules/Orders/shared/InvoiceSection.jsx